import { ChargePoint, Connector } from '../../common/redux/api/web-api'
import { CapiConnectorMode } from '../charge-point-capi-halo-control-widget'

export function toggleConnectorAvailabilityStatus(
    connector: Connector,
    isGreenChargingOn: boolean,
    chargePoint: ChargePoint
): ChargePoint {
    let selectedConnector = Object.assign(connector)
    if (selectedConnector.mode === CapiConnectorMode.ON) {
        selectedConnector = {
            ...selectedConnector,
            mode: CapiConnectorMode.OFF,
            onByUser: false,
            offByUser: true,
            onByUserOrSchedule: false,
        }
    } else if (selectedConnector.mode === CapiConnectorMode.OFF && isGreenChargingOn) {
        selectedConnector = {
            ...selectedConnector,
            mode: CapiConnectorMode.ON,
            onByUser: true,
            offByUser: false,
            onByUserOrSchedule: false,
        }
    } else if (selectedConnector.mode === CapiConnectorMode.OFF) {
        selectedConnector = {
            ...selectedConnector,
            mode: CapiConnectorMode.SCHEDULE,
            isCharging: false,
            onByUser: false,
            offByUser: false,
            onBySchedule: false,
            offBySchedule: true,
            onByUserOrSchedule: false,
        }
    } else if (selectedConnector.mode === CapiConnectorMode.SCHEDULE) {
        selectedConnector = {
            ...selectedConnector,
            mode: CapiConnectorMode.ON,
            onByUser: true,
            offByUser: false,
            onByUserOrSchedule: false,
        }
    }

    const connectors = chargePoint?.connectors?.map((connector) => {
        if (selectedConnector.connectorId !== connector.connectorId) return connector
        return selectedConnector
    })

    return { ...chargePoint, connectors }
}
